// @flow

import React from 'react';
import {
  Modal, ModalHeader, ModalBody,
} from 'reactstrap';
import './networkerror.scss';

export default class NetworkErrorModal extends React.Component {
  props: Props;

  constructor() {
    super();
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleCloseButton = this.handleCloseButton.bind(this);
    this.stopPropagation = this.stopPropagation.bind(this);
  }

  componentDidMount() {
    document.addEventListener('click', this.handleCloseModal);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleCloseModal);
  }

  handleCloseModal() {
    const { closeNetworkErrorModal } = this.props;
    closeNetworkErrorModal();
  }

  handleCloseButton() {
    const { closeNetworkErrorModal } = this.props;
    closeNetworkErrorModal();
    // eslint-disable-next-line no-restricted-globals
    location.href = '#/';
  }

  handleRetry() {
    const { runRetryFunction } = this.props;
    runRetryFunction();
  }

  stopPropagation(event) {
    event.nativeEvent.stopImmediatePropagation();
  }

  render() {
    const { networkErrorModalIsOpen, isServerError } = this.props;
    return (
      <Modal
        isOpen={networkErrorModalIsOpen}
        onClick={this.stopPropagation}
        className="modal-dialog-centered network-error-modal"
      >
        <button type="button" className="close" onClick={this.handleCloseModal} aria-label="Close">
          <svg width="17px" height="17px" className="inner-icon" viewBox="0 0 21 21" version="1.1">
            <title>Cross</title>
            <path d="M0,1 L19,20 L20,18 L2,0 L0,2 Z" fill="#071c64" />
            <path d="M19,0 L0,19 L2,20 L20,2 L18,0 Z" fill="#071c64" />
          </svg>
        </button>
        <div className="modal-icon-holder">
          <svg viewBox="0 0 140 108" width="120px" height="92.56px">
            <title>Error</title>
            <path d="M105.31,45.22A29.43,29.43,0,1,1,75.88,74.65,29.51,29.51,0,0,1,105.31,45.22Z" fill="none" strokeWidth="2px" stroke="#656597" />
            <line x1="116.24" y1="64.52" x2="94.37" y2="84.78" fill="none" strokeWidth="2px" stroke="#656597" />
            <line x1="115.44" y1="85.59" x2="95.17" y2="63.71" fill="none" strokeWidth="2px" stroke="#656597" />
            <path
              d="M122.6,38.41c-5.79-6.75-15.39-10.15-28.91-6.09C98.35-5,19.08-5,33.07,46.31c-36.63-4.58-32,56.11-1.52,42,10.1,4.81,26.53,4.81,34.74-.67"
              fill="none"
              strokeWidth="2px"
              stroke="#b5b5db"
            />
          </svg>
        </div>
        <ModalHeader>
          {isServerError ? 'Server error' : 'Network error'}
        </ModalHeader>
        <ModalBody>
          <p>
            {isServerError ? 'There was a problem connecting to server, please try later' : 'There was a network error, please check your internet connection and try again'}
          </p>
          <div className="modal-buttons">
            <button
              type="button"
              className="btn-prs dark-btn blue-bg btn-block"
              onClick={() => this.handleRetry()}
            >
              Retry
            </button>
            <button
              type="button"
              className="btn-prs btn-outline-pigdeon btn-block"
              onClick={() => this.handleCloseButton()}
            >
              Close
            </button>
          </div>
        </ModalBody>
      </Modal>
    );
  }
}
